module.exports = __webpack_public_path__ + "img/vip-crown-2-line.d27819eb.svg";